
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('pageContent', { pageContentJumbotron: 'getJumbotron' }),
      ...mapGetters('jumbotron', { genericJumbotron: 'getJumbotron' }),
      jumbotron () {
        return (this.genericJumbotron || this.pageContentJumbotron);
      }
    }
  };
